import type { App } from 'vue';

import {
    create,
    NConfigProvider,
    NMessageProvider,
    NDialogProvider,
    NInput,
    NButton,
    NForm,
    NFormItem,
    NCheckboxGroup,
    NCheckbox,
    NIcon,
    NLayout,
    NLayoutHeader,
    NLayoutContent,
    NLayoutFooter,
    NLayoutSider,
    NMenu,
    NDropdown,
    NSpace,
    NTooltip,
    NAvatar,
    NTabs,
    NTabPane,
    NCard,
    NRow,
    NCol,
    NDivider,
    NSwitch,
    NAlert,
    NElement,
    NTag,
    NNotificationProvider,
    NProgress,
    NDatePicker,
    NGrid,
    NGridItem,
    NPopover,
    NPagination,
    NSelect,
    NResult,
    NDescriptions,
    NLoadingBarProvider,
    NModal,
    NH1,
    NH3,
    NH4,
    NA,
    NScrollbar,
    NTab,
    NText,
    NH2,
    NSkeleton,
    NPopconfirm,
    NDrawer,
    NDrawerContent,
    NSpin,
    NH5,
    NInputNumber,
    NDataTable,
    NCollapse,
    NCollapseItem,
    NBackTop,
    NInputGroup,
    NEmpty,
    NRadio,
    NRadioGroup,
} from 'naive-ui';
const naive = create({
    components: [
        NMessageProvider,
        NDialogProvider,
        NConfigProvider,
        NInput,
        NInputNumber,
        NButton,
        NForm,
        NFormItem,
        NCheckboxGroup,
        NCheckbox,
        NIcon,
        NLayout,
        NLayoutHeader,
        NLayoutContent,
        NLayoutFooter,
        NLayoutSider,
        NMenu,
        NDropdown,
        NSpace,
        NTooltip,
        NAvatar,
        NTab,
        NTabs,
        NTabPane,
        NCard,
        NRow,
        NCol,
        NDivider,
        NSwitch,
        NAlert,
        NElement,
        NTag,
        NNotificationProvider,
        NProgress,
        NDatePicker,
        NGrid,
        NGridItem,
        NPopover,
        NPagination,
        NSelect,
        NResult,
        NDescriptions,
        NLoadingBarProvider,
        NModal,
        NH1,
        NH2,
        NH3,
        NH4,
        NH5,
        NA,
        NScrollbar,
        NText,
        NSkeleton,
        NPopconfirm,
        NDrawer,
        NDrawerContent,
        NSpin,
        NDataTable,
        NCollapse,
        NCollapseItem,
        NBackTop,
        NInputGroup,
        NEmpty,
        NRadio,
        NRadioGroup,
    ],
});

/**
 * setupNaive
 */
export function setupNaive(app: App<Element>): void {
    app.use(naive);
}
